import React from "react";
import { motion } from "framer-motion";

export const Different = () => {
  return (
    <section
      id="different"
      data-testid="different-section"
      className="py-10 md:py-28 bg-white relative overflow-hidden"
    >
      {/* subtle brand confetti sprinkles */}
      <div className="absolute inset-0 pointer-events-none opacity-60">
        {[
          { l: "6%",  t: "18%", c: "var(--pw-pink)"   },
          { l: "12%", t: "78%", c: "var(--pw-yellow)" },
          { l: "88%", t: "22%", c: "var(--pw-green)"  },
          { l: "92%", t: "72%", c: "var(--pw-orange)" },
          { l: "50%", t: "6%",  c: "var(--pw-purple)" },
          { l: "48%", t: "92%", c: "var(--pw-blue)"   },
        ].map((d, i) => (
          <span key={i} className="absolute w-2.5 h-2.5 rounded-full" style={{ left: d.l, top: d.t, backgroundColor: d.c }} />
        ))}
      </div>

      <div className="max-w-5xl mx-auto px-5 md:px-8 relative text-center">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="eyebrow mb-5"
        >
          Why People Watching Is Different
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-display font-black leading-[0.95] tracking-tighter"
          style={{ fontSize: "clamp(2.25rem, 6vw, 5rem)", color: "var(--pw-navy)" }}
        >
          The world provides
          <br />
          the <span className="yellow-stroke" style={{ color: "var(--pw-navy)" }}>game</span>.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-8 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-10 max-w-4xl mx-auto"
        >
          {[
            { c: "var(--pw-pink)",   label: "Every location." },
            { c: "var(--pw-yellow)", label: "Every crowd."     },
            { c: "var(--pw-orange)", label: "Every game different." },
          ].map((it, i) => (
            <div key={i} className="flex flex-col items-center gap-4">
              <span className="w-4 h-4 rounded-full" style={{ backgroundColor: it.c }} />
              <p className="font-display text-2xl md:text-3xl font-bold tracking-tight" style={{ color: "var(--pw-navy)" }}>
                {it.label}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Different;
